import { Form2553Tooltip } from '../PracticeProfileTooltips'

import { UploadItem } from './UploadItem'
import { Text, Link } from '@/ui'
import { TextColors } from '@/styles'
import { faExternalLinkAlt } from '@fortawesome/pro-regular-svg-icons'
import { UserDocumentCategoryIdentifier } from '@/features/admin/user-document-categories/userDocumentCategory.constants'

export const Form2553UploadItem = ({
  businessEntity,
  uploadButtonOnly,
}: {
  businessEntity?: string
  uploadButtonOnly?: boolean
}) => {
  return (
    <UploadItem
      label="Form 2553"
      documentCategory={UserDocumentCategoryIdentifier.form2553}
      popUpContent={<Form2553Tooltip />}
      additionalTrackingProperties={{
        document_category: 'form_2553',
        business_entity: businessEntity,
      }}
      uploadButtonOnly={uploadButtonOnly}
    >
      <Text>
        This is the form you used to apply for S Corporation status. If
        you&apos;ve lost your Form 2553, you can&apos;t request another copy of
        it. However, you can request an S Corporation verification letter (385C)
        by calling the IRS at 1-800-829-4933. You can upload either here.
      </Text>
      <Link
        className="mt-2"
        href="https://www.irs.gov/pub/irs-pdf/f2553.pdf"
        color={TextColors.BRAND}
        target="_blank"
        iconRight={faExternalLinkAlt}
      >
        Download Form
      </Link>
    </UploadItem>
  )
}
